'use client';

import dynamic from 'next/dynamic';

const CallStatus = dynamic(
  () => import('../../molecules/call-status').then((m) => m.CallStatus),
  { ssr: false },
);

export function CallStatusLoader() {
  return <CallStatus />;
}
